export default "__VITE_ASSET__iA1ys7qt__"